import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Loader from "./components/loadingScreens/Loader";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
// Put any other imports below so that CSS from your
// components takes precedence over default styles.
// import reportWebVitals from './reportWebVitals';
import { getData } from "../src/utils/AsyncStorage"
const { role,first_name} = JSON.parse(getData("userInfo") || 0);


ReactDOM.render(
  <React.StrictMode>
    {/* {
      role !== undefined ? 
      <Loader /> : null
    } */}
    <App />
    {/* <Loader /> */}
  </React.StrictMode>,
  document.getElementById("root")
);
